<ng-container *ngIf="(isMobile$ | async) === false; else mobileHeader">
  <ng-container *ngTemplateOutlet="dsHeader; context: { dsHeaderType: headerHomeLg, dsPageType: null, isMobile: false }"></ng-container>
</ng-container>

<ng-template #mobileHeader>
  <ng-container *ngIf="(dsHeaderConfig$ | async) as dsHeaderConfig">
    <ng-container *ngIf="isValidDsHeaderConfig(dsHeaderConfig?.type, dsHeaderConfig?.pageType)">
      <ng-container *ngTemplateOutlet="dsHeader; context: { dsHeaderType: dsHeaderConfig.type, dsPageType: dsHeaderConfig.pageType, isMobile: true }"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #dsHeader let-dsHeaderType="dsHeaderType" let-dsPageType="dsPageType" let-isMobile="isMobile">
  <div *ngIf="showHeader$ | async" [@transition]="headerAnimation$ | async">
    <div class="dsHeader__cont dsHeader__cont--{{dsHeaderType}}" [class.fixed]="isGenericFixed$ | async" [class.placeholder]="usePlaceholder$ | async">
      <ng-container [ngSwitch]="true">
        <ng-container *ngSwitchCase="isResultsHeader(dsHeaderType, dsPageType)">
          <app-header-results
            [dsHeaderConfig]="dsHeaderConfig$ | async"
            (widgetClicked)="widgetAction($event, isMobile)">
          </app-header-results>
        </ng-container>
        <ng-container *ngSwitchCase="isReservationHeader(dsHeaderType, dsPageType)">
          <app-header-reservation
            [dsHeaderConfig]="dsHeaderConfig$ | async"
            (widgetClicked)="widgetAction($event, isMobile)">
          </app-header-reservation>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <app-ds-header
            [type]="dsHeaderType"
            [widgetConfig]="widgets$ | async"
            [isTransparent]="isTransparent$ | async"
            [logo]="'rappi-travel-logo-full.svg'| ImageCdn"
            (clickAction)="widgetAction($event, isMobile)">
          </app-ds-header>
        </ng-container>
      </ng-container>
    </div>
    
    <ng-container *ngIf="dsHeaderEnabledSearchTabs$ | async">
      <div class="dsHeader__mobile-search-tabs">
        <app-chip-cont>
          <ng-container *ngFor="let module of countryModulesCollection$| async; index as tabNumber; trackBy: itemTrackBy">
            <div class="headerContainer__chip-cont__chip-action">
              <app-ds-chip-action
                [label]="module.title | transloco"
                [icon]="module.icon"
                [branding]="module.chipBranding"
                [chipStatus]="getChipStatus(isActivateRoute((dsHeaderConfig$ | async)?.titleKey, module.name))"
                (clickEvent)="chipActionEvent(module)">
              </app-ds-chip-action>
            </div>
          </ng-container>
        </app-chip-cont>
      </div>
    </ng-container>
  </div>

  <ng-container *ngIf="isMobile">
    <app-header-animated
      [widgets]="widgets$ | async"
      [animatedHeaderState]="animatedHeaderState"
      [dsHeaderConfig]="dsHeaderConfig$ | async"
      [isMobile]="isMobile"
      (widgetClicked)="widgetAction($event, isMobile)">
    </app-header-animated>
  </ng-container>

</ng-template>

<ng-container *ngIf="(isMobile$ | async) === false">
  <app-user-alerts-desktop
    [showAlertsManagement]="showAlertsManagement"
    [isAlertList]="isAlertListMode"
    (toggleAlertsManagement)="toggleDesktopAlertsManagement()">
  </app-user-alerts-desktop>
</ng-container>

@if (isActiveMobileInterface) {
  <app-close-webview
    [active]="showCloseWebviewModal$ | async"
    (closeWebview)="closeWebview()">
  </app-close-webview>
}

